export default __webpack_public_path__ + "static/media/icono_ok.d4450b37.png";